import { FC } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../../../components/NudosComponents';
import EditToolsDataModalContainer from './EditToolsDataModalContainer';
import { ISerialAndSKU, IlogisticServiceDetailsToolsData } from '../../../../../../../types/services';

interface IEditToolsDataModal {
  closeEditDataModal: () => void;
  toolData: IlogisticServiceDetailsToolsData;
  updateSerialAndSKU: (
    serialAndSKU?: ISerialAndSKU,
    loadingHandler?: React.Dispatch<React.SetStateAction<boolean>>
  ) => void;
}

const EditToolsDataModal: FC<IEditToolsDataModal> = ({
  closeEditDataModal,
  toolData,
  updateSerialAndSKU
}: IEditToolsDataModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={closeEditDataModal}
      modalContent={
        <NudosModalContent
          noScroll
          toCloseModal={closeEditDataModal}
          customHeight="426px"
          customWidth="580px"
          modalContentTitle="Modificar datos de la herramienta"
          CustomModalComponent={
            <EditToolsDataModalContainer toolData={toolData} updateSerialAndSKU={updateSerialAndSKU} />
          }
        />
      }
    />
  );
};

export default EditToolsDataModal;
